export const SUFFIX = '@@api/'